// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__2BY_A","selectInput":"styles_selectInput__1Xclw","attribution":"styles_attribution__2Ylyq"};